import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class PeriodService {
    constructor() {
        this.httpClient = new HttpClient()
        this.defaultLanguageCode = `fa-rIR`
    }


    getPeriodList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-periods`,
                {
                    page, size,
                    "language-code": this.defaultLanguageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewPeriod(
        title,
        numberOffDaysAllowed,
        startDate,
        endDate,
        acceptation,
        automaticAcceptance,) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `languages/${this.defaultLanguageCode}/accommodation-periods`,
                {
                    "starDate": startDate,
                    "endDate": endDate,
                    acceptation,
                    automaticAcceptance,
                    "metaData": {
                        title
                    },
                    "numberOfDaysAllowed": numberOffDaysAllowed,
                }
            ).then(resolve).catch(reject)
        })
    }

    getPeriodDetail(periodId, languageCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-periods/${periodId}`,
                {
                    "language-code": languageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePeriodDetail(periodId, languageCode, title, numberOfDaysAllowed, rules, startDate, endDate) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `languages/${languageCode}/accommodation-periods/${periodId}`,
                {
                    "starDate": startDate,
                    "endDAte": endDate,
                    "numberOfDaysAllowed": numberOfDaysAllowed,
                    "metaData": {
                        "title": title,
                        "rules": rules
                    }
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePeriodAccessForNewRequest(periodId, state) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `accommodation-periods/${periodId}/acceptations`,
                {},
                {
                    "acceptation": state
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePeriodAutomation(periodId, state) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `accommodation-periods/${periodId}/automatic-acceptances`,
                {},
                {
                    "automaticAcceptance": state
                }
            ).then(resolve).catch(reject)
        })
    }

    getHostsList(id, page, size,title) {
        return this.httpClient.get(
                `accommodation-period/${id}/accommodation-hosts`,
                {
                    "language-code": this.defaultLanguageCode,
                    page, size,title
                }
            )
    }

    getActiveHostsList(id,title, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-periods/${id}/accommodation-hosts/active-for-acceptation`,
                {
                    "language-code": this.defaultLanguageCode,
                    page, size,
                    title: title
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewResidenceToPeriod(periodId, id, menCapacity, womenCapacity, priority, activeForAcceptation, activeForAutomaticAcceptance) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `accommodation-period/${periodId}/accommodation-hosts`,
                {
                    "residenceId": id,
                    "womenCapacity": womenCapacity,
                    "menCapacity": menCapacity,
                    "priority": priority,
                    "activeForAcceptation": activeForAcceptation,
                    "activeForAutomaticAcceptance": activeForAutomaticAcceptance
                },
                {},
                {
                    "language-code": this.defaultLanguageCode,
                }
            ).then(resolve).catch(reject)
        })
    }

    getResidenceDetail(residenceId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-hosts/${residenceId}`,
                {
                    "language-code": this.defaultLanguageCode,
                }
            ).then(resolve).catch(reject)
        })
    }

    updateResidenceDetail(residenceId, priority, menNumber, womenNumber, activeForAcceptation, activeForAutomaticAcceptance) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `accommodation-hosts/${residenceId}`,
                {
                    "womenCapacity": womenNumber,
                    "menCapacity": menNumber,
                    "priority": priority,
                    "activeForAcceptation": activeForAcceptation,
                    "activeForAutomaticAcceptance": activeForAutomaticAcceptance,
                },
                {},
                {
                    "language-code": this.defaultLanguageCode,
                }
            ).then(resolve).catch(reject)
        })
    }

    getRequestListFromServer(periodId, status, order, fullName, phoneNumber, nationalCode, startDate, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-periods/${periodId}/accommodation-requests`,
                {
                    "full-name": fullName && fullName.length > 0 ? fullName :null ,
                    "phone-number": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "national-code": nationalCode && nationalCode.length > 0 ? nationalCode : null,
                    "start-date": startDate.length >= 10 ? convertPersianDateToUniversalDate(startDate) : null,
                    "status": status && status !== "ALL" && status.length > 0 ? status : null,
                    order: order,
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getRequestDetail(requestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-requests/${requestId}`,
                {
                    "language-code": this.defaultLanguageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    getResidenceDetailByRequest(requestId, hostId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-hosts/${hostId}/accommodation-requests/${requestId}`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getResidenceDetailByReserve(reserveId, hostId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-hosts/${hostId}/accommodation-reservations/${reserveId}`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    setHabitationRequest(hostId, requestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `accommodation-requests/${requestId}/accommodation-hosts/${hostId}/accommodation-reservations`,
                {
                    enabled: true
                }
            ).then(resolve).catch(reject)
        })
    }

    changeHabitationRequest(hostId, reserveId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `accommodation-reservations/${reserveId}/accommodation-hosts/${hostId}`,
            ).then(resolve).catch(reject)
        })
    }

    updateAutomaticAcceptanceLimit(id, limitAmount, limit) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `accommodation-periods/${id}/automatic-acceptance-limit`,
                {},
                {
                    "limit": limit,
                    "limitNumber": limitAmount
                }
            ).then(resolve).catch(reject)
        })
    }

    rejectRequest(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `accommodation-requests/${id}/status/rejected`
            ).then(resolve).catch(reject)
        })
    }

    rejectReserve(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `accommodation-reservations/${id}/status/rejected`
            ).then(resolve).catch(reject)
        })
    }

    getReservedList(id, hostId, fullName, phoneNumber, nationalCode, startDate, status, order, page, size) {
        console.log("start date is ", startDate)

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `accommodation-periods/${id}/accommodation-reservations`,
                {
                    page,
                    size,
                    "host-id": hostId >= 0 ? hostId : null,
                    "full-name": fullName && fullName.length > 0 ? fullName : null,
                    "phone-number": phoneNumber && phoneNumber.length > 0 ? phoneNumber : null,
                    "national-code": nationalCode && nationalCode.length > 0 ? nationalCode : null,
                    "start-date": startDate.length >= 10 ? convertPersianDateToUniversalDate(startDate) : null,
                    status: status && status !== "ALL" && status.length > 0 ? status : null,
                    order: order,
                    "language-code": this.defaultLanguageCode,
                }
            ).then(resolve).catch(reject)
        })
    }
}